import {
    REPORTS_LIST,
    REPORTS_LIST_SUCCESS,
    REPORTS_LIST_ERROR    
} from '../types';

const initialState = {
    reports: [],
    report: {},
    loading: false,
    error: false
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case REPORTS_LIST:
            return {
                ...state,
                loading: true,
                report: {},
            }
        case REPORTS_LIST_SUCCESS:
            return {
                ...state,
                reports: action.payload,
                report: {},
                loading: false,
                error: false,
            }
        case REPORTS_LIST_ERROR:
            return {
                ...state,
                reports: [],
                report: {},
                loading: false,
                error: true,
            }           
        default:
            return state;
    }
}
